
<template>
  <!--钥匙申请记录-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="applyId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-tooltip>
          <p slot="title" v-for="(item, index) of row.roomList" :key="index">{{item}}</p>
          <template v-for="(item, index) of row.roomList.slice(0, 2)">
            <div v-if="index === 0" :key="index">{{item}}</div>
            <span v-if="index === 1" :key="index">{{item}}</span>
          </template>
          <span v-if="row.roomList.length > 2">...</span>
        </a-tooltip>
      </template>

      <template slot="opt_o" slot-scope="{row}">
        <span v-for="(item, index) of rowOptList" :key="index">
          <template v-if="row.status === '0' && item.text=== '审核'">
            <a-button @click="toAudit(row)" type="link">{{item.text}}</a-button>
          </template>

          <template v-if="row.status !== '0' && item.text=== '详情'">
            <a-button @click="toAudit(row)" type="link">{{item.text}}</a-button>
          </template>
        </span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'keyApply',
  data () {
    return {
      searchList: [
        { props: ['communityId'], placeholder: '小区名称', options: [], inputType: 'select', fetchOptions: this.getOptions},
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '审核状态', options: [], inputType: 'select' },
        {
          props: ['areaId'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(3, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['applyDate'], placeholder: ['申请时间', '申请时间'], options: [], inputType: 'datePick' },
        { props: ['checkDate'], placeholder: ['审核时间', '审核时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '审核', permi: ['community:keyapply:verify'] },
        { text: '详情', permi: ['community:keyapply:verify'] }
      ],
      columns: [
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '房间', dataIndex: 'roomList', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '申请时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '审核状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'checkUser', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'checkTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'o'} }
      ],
      dataSource: [],
      searchParams: {
        communityId: undefined,
        mobile: undefined,
        status: undefined,
        areaId: [],
        propertyId: undefined,
        applyDate: [],
        checkDate: []
      },
      listApi: {
        url: '/passKeyApply/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.propertySelect(4);
      this.dictionarySelect([{index: 2, scope: 'searchList', query: 'comu_verify_type'}]);
      this.regionSelect(3);
    },
    /* 进入审核页面 */
    toAudit (row) {
      this.$router.push({
        name: 'keyApplyDetail',
        query: {
          id: row.applyId,
          status: `${row.status}`,
          title: row.status === '0' ? '审核申请钥匙' : '钥匙申请详情',
          ...this.breadParam(this)
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
